import { z } from 'zod';

/**
 * Individual field change.
 */
export const FieldChangeSchema = z.object({
  field: z.string(),
  operation: z.enum(['set', 'add', 'remove', 'update']).optional(),
  newValue: z.unknown().optional(), // Kept for backwards compatibility
  value: z.unknown().optional(),
  identifier: z.string().optional(),
  backupValue: z.string().optional(),
});

export type FieldChange = z.infer<typeof FieldChangeSchema>;

/**
 * Record of a change to an entity caused by an event.
 * Stored on the Entity document (Character, Location, Organization).
 */
export const EntityEventChangeSchema = z.object({
  eventId: z.string(),
  description: z.string().optional(),
  changes: z.array(FieldChangeSchema),
});

/**
 * Record of a change TO an entity BY an event.
 * Stored on the Event document.
 */
export const EventEntityChangeSchema = z.object({
  entityId: z.string(),
  entityName: z.string(),
  entityType: z.string(), // e.g., 'character', 'location', 'organization'
  description: z.string().optional(),
  changes: z.array(FieldChangeSchema),
});

export type EntityEventChange = z.infer<typeof EntityEventChangeSchema>;
export type EventEntityChange = z.infer<typeof EventEntityChangeSchema>;
